import { GridRow, mixins, styled } from '@bob/library'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'

export const StyledHeaderGridRow = styled(GridRow)`
  ${mixins.margin(30, 0)}
`
export const StyledCaption = styled.h4`
  ${mixins.typography.paragraphMedium};
`
export const StyledHeader = styled.h1`
  ${mixins.typography.headlineXl};
  ${mixins.margin(10, 0)};
`
export const StyledLink = styled(SpotLinkAnchor)`
  ${mixins.padding.left(0)};
`
